export enum PluginIndentifierEnum {
    WHATSAPP_BOT = 'WHATSAPP_BOT',
    PUBLIC_API = 'PUBLIC_API',
}

export enum PluginCameraIndentifierEnum {
    AI = 'AI',
    // BIM = 'BIM',
}
